// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/__template';
import model_2 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/contractPage';
import model_3 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/loginPage';
import model_4 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/logonPage';
import model_5 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/retrievePage';
import model_6 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/retrievePayPasswordPage';
import model_7 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/rewardPage';
import model_8 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/settingPage';
import model_9 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/user';
import model_10 from 'C:/code/freelogfe/freelogfe-web-repos/packages/user-umi4/src/models/walletPage';

export const models = {
model_1: { namespace: '__template', model: model_1 },
model_2: { namespace: 'contractPage', model: model_2 },
model_3: { namespace: 'loginPage', model: model_3 },
model_4: { namespace: 'logonPage', model: model_4 },
model_5: { namespace: 'retrievePage', model: model_5 },
model_6: { namespace: 'retrievePayPasswordPage', model: model_6 },
model_7: { namespace: 'rewardPage', model: model_7 },
model_8: { namespace: 'settingPage', model: model_8 },
model_9: { namespace: 'user', model: model_9 },
model_10: { namespace: 'walletPage', model: model_10 },
} as const
